export enum ProjectListColumnKey {
  MEMBERS = 'members',
  STATUS = 'status',
  UPDATED = 'updated',
  ROI = 'roi',
  ROI_2 = 'roi_2',
  ROI_5 = 'roi_5',
  BEP = 'bep',
}

export type ProjectListColumn = {
  readonly key: ProjectListColumnKey;
  readonly enabled: boolean;
};
